var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96875 15.0034H21.9688C22.6562 15.0034 23.2188 14.4409 23.2188 13.7534C23.2188 13.0659 22.6562 12.5034 21.9688 12.5034H1.96875C1.28125 12.5034 0.71875 13.0659 0.71875 13.7534C0.71875 14.4409 1.28125 15.0034 1.96875 15.0034ZM1.96875 8.75342H21.9688C22.6562 8.75342 23.2188 8.19092 23.2188 7.50342C23.2188 6.81592 22.6562 6.25342 21.9688 6.25342H1.96875C1.28125 6.25342 0.71875 6.81592 0.71875 7.50342C0.71875 8.19092 1.28125 8.75342 1.96875 8.75342ZM0.71875 1.25342C0.71875 1.94092 1.28125 2.50342 1.96875 2.50342H21.9688C22.6562 2.50342 23.2188 1.94092 23.2188 1.25342C23.2188 0.565918 22.6562 0.00341797 21.9688 0.00341797H1.96875C1.28125 0.00341797 0.71875 0.565918 0.71875 1.25342Z",
    fill: "#35364E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationBurger);
export default __webpack_public_path__ + "static/media/navigation_burger.89a6a28e877df36d9f3cfb276a0c801c.svg";
export { ForwardRef as ReactComponent };